import angular from 'angular'
import routers from './routers.js'
import abnormalTaskTrackingCtrl from './abnormalTaskTrackingCtrl'
import fieldConfig from './fieldConfig.js'

export default angular
    .module('declaration.declareASummary.abnormalTaskTracking', [])
    .config([
        '$stateProvider',
        ($stateProvider) => {
            Object.keys(routers).forEach((router) => {
                $stateProvider.state(routers[router].state, routers[router].config)
            })
        },
    ])
    .controller('abnormalTaskTrackingCtrl', abnormalTaskTrackingCtrl)
    .value('ATTFieldConfig', fieldConfig).name



// WEBPACK FOOTER //
// ./src/app/declaration/declareASummary/abnormalTaskTracking/index.js